import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgDepositLimits = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path fill="hsl(var(--system-icon-white))" d="m31 13-9.5 6h20z" />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M27.089 13.48c2.389-1.584 5.6-1.584 7.989 0l6.848 4.54a1.375 1.375 0 0 1-1.519 2.293l-6.85-4.54c-1.467-.974-3.48-.974-4.948 0l-6.85 4.54a1.375 1.375 0 0 1-1.518-2.292z"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M48.436 28.333c-.143-3.432-.602-5.537-2.084-7.018-2.148-2.148-5.605-2.148-12.519-2.148h-5.5c-6.914 0-10.37 0-12.518 2.147-2.148 2.148-2.148 5.605-2.148 12.52 0 6.913 0 10.37 2.148 12.518C17.962 48.5 21.419 48.5 28.333 48.5h5.5c6.914 0 10.371 0 12.519-2.148 1.482-1.481 1.941-3.586 2.084-7.019"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M12.292 33.833c0-3.418-.003-6.12.28-8.23.29-2.15.899-3.888 2.27-5.26 1.373-1.372 3.112-1.981 5.261-2.27 2.11-.284 4.812-.281 8.23-.281h5.5c3.418 0 6.12-.003 8.23.28 2.15.29 3.889.899 5.26 2.27 1.887 1.887 2.343 4.485 2.486 7.934l-2.747.115c-.142-3.416-.605-5.027-1.683-6.104-.775-.776-1.838-1.241-3.682-1.49-1.885-.253-4.368-.255-7.864-.255h-5.5c-3.495 0-5.979.002-7.863.256-1.844.248-2.907.713-3.683 1.49-.776.775-1.241 1.838-1.49 3.682-.253 1.884-.255 4.368-.255 7.863s.002 5.98.256 7.864c.248 1.844.713 2.907 1.49 3.682.775.776 1.837 1.242 3.682 1.49 1.884.253 4.368.256 7.863.256h5.5c3.496 0 5.98-.003 7.864-.256 1.844-.248 2.907-.714 3.682-1.49 1.077-1.076 1.541-2.687 1.683-6.103l2.747.115c-.143 3.449-.6 6.047-2.485 7.933-1.372 1.372-3.111 1.98-5.26 2.27-2.11.284-4.813.281-8.23.281h-5.5c-3.419 0-6.121.003-8.231-.281-2.15-.29-3.888-.898-5.26-2.27s-1.981-3.111-2.27-5.26c-.284-2.11-.281-4.813-.281-8.23"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M28.333 25.125a1.375 1.375 0 1 1 0 2.75H21a1.375 1.375 0 1 1 0-2.75z"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M48.194 28.333h-4.77c-3.272 0-5.924 2.463-5.924 5.5s2.652 5.5 5.923 5.5h4.771c.153 0 .23 0 .294-.003.989-.06 1.776-.792 1.841-1.71.004-.06.004-.131.004-.273V30.32c0-.141 0-.212-.004-.272-.065-.918-.852-1.65-1.841-1.71-.065-.004-.14-.004-.294-.004"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M48.958 30.143c-.01-.153-.174-.41-.553-.433v-.002h-4.983c-2.609 0-4.547 1.942-4.547 4.125 0 2.184 1.938 4.125 4.547 4.125h4.772c.168 0 .197 0 .211-.002l.133-.017c.285-.067.41-.282.42-.416zm2.75 7.205-.007.369c-.119 1.683-1.532 2.887-3.13 2.984h-.001a7 7 0 0 1-.376.007h-4.772c-3.932 0-7.297-2.984-7.297-6.875s3.365-6.874 7.297-6.875h4.772c.133 0 .26 0 .376.008h.002c1.597.097 3.01 1.301 3.13 2.984l.006.369z"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M43 32a1.833 1.833 0 0 1 0 3.667h-.016a1.833 1.833 0 0 1 0-3.667z"
      />
    </svg>
  );
};
export default SvgDepositLimits;
